export const E_INVOICE_APP = 'E_INVOICE';

export const READ_CUSTOMER = 'READ_CUSTOMER';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';

export const READ_SALE_INVOICE = 'READ_SALE_INVOICE';
export const CREATE_SALE_INVOICE = 'CREATE_SALE_INVOICE';
export const UPDATE_SALE_INVOICE = 'UPDATE_SALE_INVOICE';

export const READ_SALE_CREDIT_NOTE = 'READ_SALE_CREDIT_NOTE';
export const CREATE_SALE_CREDIT_NOTE = 'CREATE_SALE_CREDIT_NOTE';
export const UPDATE_SALE_CREDIT_NOTE = 'UPDATE_SALE_CREDIT_NOTE';

export const READ_PROFORMA_INVOICE = 'READ_PROFORMA_INVOICE';
export const CREATE_PROFORMA_INVOICE = 'CREATE_PROFORMA_INVOICE';
export const UPDATE_PROFORMA_INVOICE = 'UPDATE_PROFORMA_INVOICE';

export const READ_SALE_REGISTER = 'READ_SALE_REGISTER';
export const CREATE_SALE_REGISTER = 'CREATE_SALE_REGISTER';
export const UPDATE_SALE_REGISTER = 'UPDATE_SALE_REGISTER';

export const READ_PURCHASE_INVOICE = 'READ_PURCHASE_INVOICE';
export const CREATE_PURCHASE_INVOICE = 'CREATE_PURCHASE_INVOICE';
export const UPDATE_PURCHASE_INVOICE = 'UPDATE_PURCHASE_INVOICE';

export const READ_PURCHASE_CREDIT_NOTE = 'READ_PURCHASE_CREDIT_NOTE';
export const CREATE_PURCHASE_CREDIT_NOTE = 'CREATE_PURCHASE_CREDIT_NOTE';
export const UPDATE_PURCHASE_CREDIT_NOTE = 'UPDATE_PURCHASE_CREDIT_NOTE';

export const READ_SUPPLIER = 'READ_SUPPLIER';
export const CREATE_SUPPLIER = 'CREATE_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const ARCHIVE_SUPPLIER = 'ARCHIVE_SUPPLIER';

export const READ_PURCHASE_REGISTER = 'READ_PURCHASE_REGISTER';
export const CREATE_PURCHASE_REGISTER = 'CREATE_PURCHASE_REGISTER';
export const UPDATE_PURCHASE_REGISTER = 'UPDATE_PURCHASE_REGISTER';
export const ARCHIVE_PURCHASE_REGISTER = 'ARCHIVE_PURCHASE_REGISTER';

export const READ_PRODUCT = 'READ_PRODUCT';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const ARCHIVE_PRODUCT = 'ARCHIVE_PRODUCT';

export const READ_DOCUMENT_REPORT = 'READ_DOCUMENT_REPORT';
export const CREATE_DOCUMENT_REPORT = 'CREATE_DOCUMENT_REPORT';

export const READ_VAT_REPORT = 'READ_VAT_REPORT';
export const CREATE_VAT_REPORT = 'CREATE_VAT_REPORT';

export const READ_BULK_UPLOAD = 'READ_BULK_UPLOAD';
export const WRITE_BULK_UPLOAD = 'WRITE_BULK_UPLOAD';

export const READ_BUSINESS_PROFILE = 'READ_BUSINESS_PROFILE';
export const CREATE_BUSINESS_PROFILE = 'CREATE_BUSINESS_PROFILE';
export const UPDATE_BUSINESS_PROFILE = 'UPDATE_BUSINESS_PROFILE';
export const CLAIM_BUSINESS_PROFILE = 'CLAIM_BUSINESS_PROFILE';
